export default __webpack_public_path__ + "0325268729afc24488b9cd1b91b2a5c5.png";